function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.58323 3.91234H9.59515C9.69358 3.91234 9.74144 4.03265 9.67034 4.09964L1.7639 11.6438C1.6846 11.7203 1.55608 11.6451 1.58206 11.5385L2.80433 6.64945H0.419952C0.335186 6.64945 0.283233 6.55785 0.325616 6.48538L3.868 0.36722C3.88714 0.33304 3.92405 0.312532 3.96233 0.312532H9.2055C9.2971 0.312532 9.34769 0.417806 9.29163 0.490267L6.58323 3.91234ZM3.99648 5.7199L3.1721 9.01468L3.17221 9.01458L3.99656 5.7199H3.99648ZM1.84469 5.71976H1.84456L4.43675 1.24359H7.50745L7.50734 1.24373H4.4368L1.84469 5.71976ZM4.65976 4.84339H7.54436L7.54421 4.84354H4.65965L4.65976 4.84339Z",
  fill: "currentColor",
  fillOpacity: 0.65
});

var SvgThunderbolt = function SvgThunderbolt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThunderbolt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thunderbolt.978e2cd4.svg";
export { ForwardRef as ReactComponent };